import {defineComponent} from 'vue';

export default defineComponent({
    name: 'Signalr',
    props: {},
    setup(props) {
    }
})
